import PublicNav from '@/components/layout/PublicNav';
import PublicFooter from '@/components/layout/PublicFooter';
import { useSEO } from '@/hooks/useSEO';

export default function PrivacyPage() {
  useSEO({ title: 'Privacy Policy — YuHasPro', description: 'How YuHasPro collects, uses, and protects your data.' });

  return (
    <div className="bg-background text-foreground min-h-screen">
      <PublicNav />
      <main className="pt-28 pb-20 px-6 lg:px-12 max-w-3xl mx-auto">
        <h1 className="font-display text-3xl font-extrabold tracking-tight mb-8">Privacy Policy</h1>
        <div className="prose prose-sm text-muted-foreground space-y-6 text-[13px] leading-relaxed">
          <p><strong>Last updated:</strong> March 2026</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">1. Information We Collect</h2>
          <p>We collect information you provide when creating an account (name, email, phone), data you enter into the platform (leads, student records, fee information), and usage data (pages visited, features used) to improve our service.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">2. How We Use Your Information</h2>
          <p>Your data is used to provide and maintain the YuHasPro platform, send transactional communications, improve our service, and comply with legal obligations. We do not sell your personal data to third parties.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">3. Data Storage & Security</h2>
          <p>Data is stored on secure, encrypted servers. We implement industry-standard security measures including encryption in transit (TLS) and at rest, role-based access controls, and regular security audits.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">4. Data Retention</h2>
          <p>We retain your data for as long as your account is active. Upon account deletion, your data is permanently removed within 30 days, except where retention is required by law.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">5. Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal data at any time by contacting us at privacy@yuhaspro.in.</p>

          <h2 className="font-display text-lg font-bold text-foreground mt-8 mb-3">6. Contact</h2>
          <p>For privacy-related inquiries, reach us at <strong>privacy@yuhaspro.in</strong>.</p>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
